import { gql } from "@apollo/client";
import { NotificationFragment } from "./fragment";

export const NOTIFICATION_SUBSCRIPTION = gql`
  subscription notification($viewerClient:ID)  {
    notification(viewerClient:$viewerClient) {
      ...NotificationFragment
    }
  }
  ${NotificationFragment}
`;
